import { LICENSE_SETTINGS_INITIAL_STATE } from './chunk-OQYBQD74.mjs';
import { SET_LICENSE_SETTINGS, SET_LANGUAGE, SET_TEXT_SIZE, SET_IS_DARK_MODE } from './chunk-WXPNHPDE.mjs';
import { produce } from 'immer';

var licenseSettingsReducer = produce((state = LICENSE_SETTINGS_INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_IS_DARK_MODE:
      state.displayMode = action.payload;
      break;
    case SET_TEXT_SIZE:
      state.fontSize = action.payload;
      break;
    case SET_LANGUAGE:
      state.language = action.payload;
      break;
    case SET_LICENSE_SETTINGS:
      return action.payload;
    default:
      return state;
  }
});
var reducers_default = licenseSettingsReducer;

export { reducers_default };
